import { fetchWithAuth } from './apiHelpers';

/**
 * Checks if the user has any integrations connected
 * @returns {Promise<boolean>} True if user has at least one integration, false otherwise
 */
export const hasIntegrations = async () => {
  try {
    const response = await fetchWithAuth('/api/auth_update/', {
      method: 'GET',
    });

    if (!response.ok) {
      throw new Error('Failed to fetch integrations');
    }

    const data = await response.json();

    // Check if the user has any integrations
    return data.integration && data.integration.length > 0;
  } catch (error) {
    console.error('Error checking integrations:', error);
    return false;
  }
};

/**
 * Redirects to integration settings page if user has no integrations
 * @param {boolean} showReskin - Whether the reskinned experience is enabled
 * @returns {Promise<boolean>} True if redirected, false otherwise
 */
export const redirectIfNoIntegrations = async (showReskin = false) => {
  const hasUserIntegrations = await hasIntegrations();

  if (!hasUserIntegrations) {
    // Store a flag in localStorage to prevent infinite redirects
    if (!localStorage.getItem('redirectedToIntegrations')) {
      localStorage.setItem('redirectedToIntegrations', 'true');

      // Redirect based on feature flag
      if (showReskin) {
        window.location.href = '/integrations';
      } else {
        window.location.href = '/Dash?view=integrationSettings';
      }

      return true;
    }
  } else {
    // Clear the flag if user has integrations
    localStorage.removeItem('redirectedToIntegrations');
  }

  return false;
};
